module.exports = {
	"adobe": {
		"path": "adobe",
		"short_name": "Adobe"
	},
	"airbnb": {
		"path": "airbnb",
		"short_name": "Airbnb"
	},
	"amazon-com": {
		"path": "amazon_com",
		"short_name": "Amazon.com"
	},
	"apple": {
		"path": "apple",
		"short_name": "Apple"
	},
	"campbell-soup": {
		"path": "campbell_soup",
		"short_name": "Campbell Soup Company"
	},
	"comcast": {
		"path": "comcast",
		"short_name": "Comcast"
	},
	"disney": {
		"path": "disney",
		"short_name": "Disney"
	},
	"facebook": {
		"path": "facebook",
		"short_name": "Facebook"
	},
	"google": {
		"path": "google",
		"short_name": "Google"
	},
	"microsoft": {
		"path": "microsoft",
		"short_name": "Microsoft"
	},
	"netflix": {
		"path": "netflix",
		"short_name": "Netflix"
	},
	"pinterest": {
		"path": "pinterest",
		"short_name": "Pinterest"
	},
	"qualcomm": {
		"path": "qualcomm",
		"short_name": "Qualcomm"
	},
	"state-farm": {
		"path": "state_farm",
		"short_name": "State Farm"
	},
	"visa": {
		"path": "visa",
		"short_name": "VISA"
	},
	"whole-foods": {
		"path": "whole_foods",
		"short_name": "Whole Foods"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/PlanNames.json
// module id = 1012
// module chunks = 0